export enum AsyncActionState {
    Pending = "Pending",
    Success = "Success",
    Error = "Error",
    Reset = "Reset"
}
